import IdManager from './IdManager/index'

import DinnerSvg from './dinnerSvg/index'

import Layer from '../modules/Layers/index'

import utils from '../modules/utils/index'

import constants from '../modules/constants/index'

export default class extends Layer {
  constructor(svg) {
    super()

    this.id = IdManager.next()

    this.svg = svg

    this.defaultMatrix = [1, 0, 0, 1, 0, 0]

    // start

    this.shapes = {}

    this.lines = {}

    this.shapeDefs = {}

    this.lineDefs = {}

    this.matrix = [1, 0, 0, 1, 0, 0]

    this.focusObjectId = ""

    this.ghostShape = null

    this.ghostLine = null

    this.panningPointId = null

    this.panningGroup = null


    this.dirty = false

    this.mode = 255

    this.isPanningBackground = false

    this.selectPath = null

    this.selectsObjectIds = {}

    this.typeNameVisible = true

    this.colorOfShapes = {}

    this.tool = constants.tools.hand

    let renderHandler = null
      , dinnerSvg = new DinnerSvg(this.svg)

    utils.watch(this, [
      "shapes", "lines", "shapeDefs", "lineDefs", "matrix", "focusObjectId", "ghostShape", "ghostLine", "snappedX", "snappedY", "panningPointId", "panningGroup", "mode", "isPanningBackground", "selectPath", "selectsObjectIds", "typeNameVisible", "colorOfShapes", "tool"
    ], (name, preVal, value) => {

      clearTimeout(renderHandler)
      renderHandler = setTimeout(() => {
        dinnerSvg.update(super.display())

        switch (name) {
          case "matrix": {
            this.emit("changeMatrix", preVal, value)
            break
          }
          case "shapes":
          case "lines": {
            if (!this.dirty) {
              this.dirty = true
              this.emit("dirty")
            }
            break
          }
        }
      }, 0)
    });
    // end

    this.install()
  }



  get data() {
    return {
      "sequence-flow": Object.keys(this.lines).map(lineId => {
        let { id, type, targetShapeId, sourceShapeId, points,tip } = this.lines[lineId]
        return {
          id,
          "to": targetShapeId,
          "points": {
            "start": `${points[0].x},${points[0].y}`,
            "middle": points.slice(1, -1).map(({ x, y }) => `${x},${y}`),
            "end": `${points[points.length - 1].x},${points[points.length - 1].y}`
          },
          "from": sourceShapeId,
          type,
          tip
        }
      }),
      "board": { // 为了兼容？
        "scale": 1.21875,
        "dimension": {
          "w": 1170,
          "h": 419,
          "y": 99,
          "x": 0
        },
        "box": {
          "xMax": 960,
          "yMax": 320
        }
      },
      "activity": Object.keys(this.shapes).map(shapeId => {
        let { id, matrix, name, type } = this.shapes[shapeId]
        return {
          "position": {
            "x": matrix[4],
            "y": matrix[5]
          },
          id,
          "name": name,
          type
        }
      }),
      "editor-version": "1"
    }
  }

  set data(data) {

    this.shapes = data["activity"].reduce((p, c, i, a) => {
      let { position: { x, y }, id, name, type } = c
      x = +x
      y = +y
      p[id] = {
        id,
        matrix: [1, 0, 0, 1, x, y],
        name,
        type
      }
      return p
    }, {})

    this.lines = data["sequence-flow"].reduce((p, c, i, a) => {
      let { id, to, points: { start, middle, end }, from, type,tip } = c
      , line = {
        id,
        type,
        tip,
        targetShapeId: to,
        sourceShapeId: from,
        targetPoint: { x: 0, y: 0 },
        sourcePoint: { x: 0, y: 0 },
        points: [start, ...middle, end].reduce((p, c, i, a) => {
          let [x, y] = c.split(",")
          x = +x
          y = +y
          return [...p, { x, y }]
        }, [])
      }
      , points = this.getPoints(line)
      line.points = points
      p[id] = line
      return p
    }, {})

    this.blur()

    this.colorOfShapes = {}

    this.selectsObjectIds = {}

    setTimeout(() => {
      this.dirty = false
    }, 0)
  }

  clear() {
    this.shapes = {}
    this.lines = {}
    this.blur()
    this.colorOfShapes = {}
    this.selectsObjectIds = {}
  }

  applyDefault() {
    // 1, add markers
    let markerDefs = Snap.parse(`<defs>
      <marker 
        id=${this.id + 'normalMarkerArrow'}
        markerWidth='16'
        markerHeight='12'
        orient='auto' 
        viewBox='-12 -6 16 12'
        markerUnits='userSpaceOnUse'
      >
        <path fill=${"#336699"} d='M-14,-6 L2,0 L-14,6 L-8,0 L-14,-6' />
      </marker>
      <marker 
        id=${this.id + 'normalMarkerArrowFocus'}
        markerWidth='16'
        markerHeight='12'
        orient='auto' 
        viewBox='-12 -6 16 12'
        markerUnits='userSpaceOnUse'
      >
        <path fill=${"red"} d='M-14,-6 L2,0 L-14,6 L-8,0 L-14,-6' />
      </marker>

      <marker 
        id=${this.id + 'startSubProcessMarkerArrow'}
        markerWidth='16'
        markerHeight='12'
        orient='auto' 
        viewBox='-12 -6 16 12'
        markerUnits='userSpaceOnUse'
      >
        <path fill=${"#99aa99"} d='M-14,-6 L2,0 L-14,6 L-8,0 L-14,-6' />
      </marker>
      <marker 
      id=${this.id + 'startSubProcessMarkerArrowFocus'}
      markerWidth='16'
      markerHeight='12'
      orient='auto' 
      viewBox='-12 -6 16 12'
      markerUnits='userSpaceOnUse'
    >
      <path fill=${"red"} d='M-14,-6 L2,0 L-14,6 L-8,0 L-14,-6' />
    </marker>
    </defs>`).node.firstChild

    this.svg.appendChild(markerDefs)

    // 2, add shapes
    ;[
      {
        type: "normal", //普通
        fill: "lightblue",
        typeName: "普通",
        meta: {
          lineButtonTypes: ["normal"]
        }
      },
      {
        type: "parallel", //并行
        fill: "lightblue",
        typeName: "并行",
        meta: {
          lineButtonTypes: ["normal"]
        }
      },
      {
        type: "sub-proc", //子流程
        fill: "lightblue",
        typeName: "子流程",
        meta: {
          lineButtonTypes: ["normal"]
        }
      },
      {
        type: "circular", //传阅
        fill: "lightblue",
        typeName: "传阅",
        meta: {
          lineButtonTypes: ["normal"]
        }
      },
      {
        type: "serial", //串行
        fill: "lightblue",
        typeName: "串行",
        meta: {
          lineButtonTypes: ["normal"]
        }
      },
      {
        type: "dynamic", //动态
        fill: "lightblue",
        typeName: "动态",
        meta: {
          lineButtonTypes: ["normal"]
        }
      },
      {
        type: "proxy", //代理事件
        fill: "lightblue",
        typeName: "代理事件",
        meta: {
          lineButtonTypes: ["normal"]
        }
      }
    ].forEach(({type, typeName, fill, meta}) => {
      this.addShape(type, typeName, `<rect x="50" y="50" rx="5" ry="5" width="100" height="50" fill="${fill}" filter="url(#nodeFilter)"  fill-opacity="1" stroke="#000" stroke-width="0"></rect>`, meta)
    })

    ;[
      {
        type: "start", // 开始节点
        fill: "lightgreen",
        typeName: "",
        meta: {
          lineButtonTypes: ["normal"]
        }
      },
      {
        type: "end", //结束节点
        fill: "lightcoral",
        typeName: ""
      }
    ].forEach(({type, typeName, fill, meta}) => {
      this.addShape(type, typeName, `<circle cx="0" cy="0" r="25"  stroke="#000" stroke-width="0"  fill="${fill}" filter="url(#nodeFilter)" fill-opacity="1" ></circle>`, meta)
    })

    ;[
      {
        type: "normal",
        name: "新建普通流向",
        style: {
          stroke: "#336699",
          "stroke-width": 2,
          "fill": "none",
          "marker-end": `url(#${this.id + 'normalMarkerArrow'})`
        },
        focusStyle: {
          stroke: "red",
          "marker-end": `url(#${this.id + 'normalMarkerArrowFocus'})`
        }
      },
      {
        type: "startSubProcess",
        name: "运转",
        style: {
          stroke: "#99aa99",
          "stroke-width": 2,
          "fill": "none",
          "stroke-dasharray":"5,3",
          "marker-end": `url(#${this.id + 'startSubProcessMarkerArrow'})`
        },
        focusStyle: {
          stroke: "red",
          "marker-end": `url(#${this.id + 'startSubProcessMarkerArrowFocus'})`
        }
      },
      {
        type: "sendHandled",
        name: "直送经办",
        style: {
          stroke: "#336699",
          "stroke-width": 2,
          "fill": "none",
          "marker-end": `url(#${this.id + 'startSubProcessMarkerArrow'})`
        },
        focusStyle: {
          stroke: "red",
          "marker-end": `url(#${this.id + 'startSubProcessMarkerArrowFocus'})`
        }
      }
    ].forEach(({type, style, name, focusStyle}) => {
      this.addLine(type, name, style, focusStyle)
    })

    this.on("createLine", line => {
      let {id} = line
      setTimeout(() => {
        this.focusLine({id})
      }, 0)
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/index.js